export enum SkyproAvailableLanguages {
  ru = 'ru',
  en = 'en',
}

export const skyproAvailableLanguages = Object.values(SkyproAvailableLanguages);

export type SkyproAvailableLanguagesType = keyof typeof SkyproAvailableLanguages;
